<div class="app-component-container" id="service-details">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <app-base-single-column-image-button [elementIds]="elementSignals['base-single-column-image-button']()"></app-base-single-column-image-button>
</div>